export { Application as ApplicationLayout } from './Application';
